<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('Warehouse.JobNumberInformation')"
      width="200px"
      class="make-invoice-adjust-balance-dialog"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div>
        <div>
          <div class="form-row" style="flex-direction:row;max-width: 920px">
            <el-form
              label-width="100px"
              label-position="left"
              style="margin-right:20px"
            >
              <cargo-ag-grid
                ref="jobsList"
                :show-side-bar="false"
                :grid-options="options"
                :column-defs="column"
                :row-data="jobNos"
                style="width: 100%;min-width: 180px"
                @gridReady="params=>{gridApi=params.api}"
              />
            </el-form>
          </div>
        </div>
        <div class="spacing" />
        <div class="triggers" align="right">
          <el-button no="confirm" type="primary" @click="selectedHandler">
            {{ $t('common.btn.confirm') }}
          </el-button>

          <el-button no="close" type="primary" @click="cancel">
            {{ $t('common.btn.close') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'

export default {
  name: 'JobNosWindow',
  components: { CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    jobNos: { type: Array, required: false }
  },
  data() {
    return {
      loading: false,
      gridApi: null,
      options: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        selectedRowIndex: -1,
        // 选中
        onCellFocused: (event) => {
          this.onSelectedRow(event)
        },
        context: {
          componentParent: this
        },
        columnApi: null
      },
      column: [
        {
          headerName: this.$t('queryJob.businessNumber'), colId: 'jobNo', field: 'jobNo', minWidth: 160,
          editable: false
        }
      ]
    }
  },
  computed: {
    innerVisible() {
      return this.visible
    }
  },
  async beforeMount() {

  },
  mounted() {
  },
  methods: {
    cancel() {
      this.$emit('update:visible', false)
    },
    onSelectedRow(event) {
      if (!this.jobNos) {
        return
      }
      this.options.selectedRowIndex = event.rowIndex
    },
    selectedHandler() {
      const j = this.jobNos[this.options.selectedRowIndex]
      if (!j) {
        this.$message.warning(this.$t('Message.PleaseSelectABusinessNumber'))
        return
      }
      this.$emit('selectJobNoHandler', j.jobKey)
      this.$emit('update:visible', false)
    }
  }
}
</script>
<style scoped>

ul li {
  list-style: none;
  font-size: 13px;
  color: #909399;
}

.spacing {
  padding-top: 20px;
}
</style>

